<template>
    <div>
        <v-label v-if="label">{{ label }}</v-label>
        <textarea ref="textarea" rows="1"
                  class="w-full border rounded border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 shadow-sm text-xs"
                  @change="update"
                  v-model="proxyValue"
                  @focus="resize"
                  @keyup="resize"
        >{{ modelValue }}</textarea>
        <v-input-error :message="error" />
        <v-input-error :message="errorJson" />
    </div>
</template>

<script>

import VLabel from '@/Components/Label';
import VInputError from '@/Components/InputError';

export default {
    components: {
        VLabel,
        VInputError,
    },
    props: {
        label: {
            type: String,
            default: null,
        },
        modelValue: Object,
        error: Object,
    },
    data() {
        return {
            saveProxyValue: null,
            errorJson: null,
        }
    },
    mounted() {
        this.resize();
    },
    computed: {
        proxyValue: {
            get() {
                return this.saveProxyValue || JSON.stringify(this.modelValue, null, 2);
            },
            set(val) {
                this.saveProxyValue = val;
            }
        },
    },
    methods: {
        update() {
            this.errorJson = null;
            try{
                const val = JSON.parse(this.saveProxyValue);
                this.$emit("update:modelValue", val);
                this.saveProxyValue = JSON.stringify(val, null, 2);
            } catch (e) {
                this.errorJson = e.message;
            }
        },
        resize() {
            const { textarea } = this.$refs;
            textarea.style.height = '1px';
            textarea.style.height = `${textarea.scrollHeight + 4}px`;
        },
    },
}
</script>
